import { useProfileStore } from 'src/stores/useProfileStore';
import { SubscriptionType, Subscription } from 'src/constants/subscription';

type SubscriptionTier = { value?: number; label?: string } | string;

export function hasRightAccess(subType: SubscriptionType, subTier: SubscriptionTier): boolean | undefined {
  let tier = subTier;
  if (typeof tier === 'string') tier = { value: Subscription[tier as keyof typeof Subscription].value, label: tier };
  const profile = useProfileStore();
  if (subType === SubscriptionType.COMPLIANCE) return profile.complianceSubscription.value >= tier.value;
  else if (subType === SubscriptionType.DECLARATIVE) return profile.declarativeSubscription.value >= tier.value;
  else if (subType === SubscriptionType.CUSTOMS_BASE)
    return profile.customsbaseSubscription.label !== Subscription.FREE.label;
  else if (subType === SubscriptionType.ANY)
    return (
      profile.complianceSubscription.value >= tier.value ||
      profile.declarativeSubscription.value >= tier.value ||
      profile.customsbaseSubscription.value >= tier.value
    );
}
